export default __webpack_public_path__ + "static/media/mistral-reseaux.35b31286.jpg";